import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import StoreModal from './StoreModal';
import './Navbar.css';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [storeModalOpen, setStoreModalOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setMenuOpen(false), [location]);

  const links = [
    { to: '/', label: 'Home' },
    { to: '/how-it-works', label: 'How It Works' },
    { to: '/services', label: 'Services' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <>
      <nav className="navbar">
        <div className="container nav-inner">
          <Link to="/" className="nav-logo">
            <span className="logo-icon">AX</span>
            <span className="logo-text">AfreXpert</span>
          </Link>

          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            {links.map(l => (
              <li key={l.to}>
                <Link to={l.to} className={`nav-link ${location.pathname === l.to ? 'active' : ''}`}>
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <button className="btn-primary nav-cta" onClick={() => setStoreModalOpen(true)}>
                Download App
              </button>
            </li>
          </ul>

          <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {storeModalOpen && <StoreModal onClose={() => setStoreModalOpen(false)} />}
    </>
  );
}
